import { defineStore } from 'pinia';
import type { Channel } from '@getaccept/pusher';
import { ChannelType } from '@getaccept/pusher';
import type { Conversation } from '@getaccept/dsr-shared-new';
import { ref } from 'vue';
import { pusherClient } from '../../api/pusher/pusher-client';
import type { PusherChannels } from '../types/pusher-state';

export const usePusherStore = defineStore('published-pusher', () => {
  const channels = ref(<PusherChannels>{
    conversations: {},
    dealroom: null,
    editor: [],
  });

  const setConversationChannels = async (conversations: Conversation[]) => {
    for (const conversation of conversations) {
      const existingChannel = channels.value.conversations[conversation.id];
      if (!existingChannel) {
        const newChannel: Channel = await pusherClient.subscribe(
          ChannelType.Conversation,
          conversation.id
        );
        channels.value.conversations = {
          ...channels.value.conversations,
          [conversation.id]: newChannel,
        };
      }
    }
  };

  const setDealroomChannel = async (id: string) => {
    channels.value.dealroom = await pusherClient.subscribe(ChannelType.Dealroom, id);
  };

  const subscribeToEditorChannels = async (contentIds: string[]) => {
    channels.value.editor = await Promise.all(
      contentIds.map((contentId: string) => pusherClient.subscribe(ChannelType.Editor, contentId))
    );
  };
  const unsubscribeFromEditorChannels = () => {
    channels.value.editor.forEach(channel => {
      pusherClient.unsubscribe(channel as Channel);
    });
  };
  return {
    channels,
    setConversationChannels,
    setDealroomChannel,
    subscribeToEditorChannels,
    unsubscribeFromEditorChannels,
  };
});
